<template>
  <div
    class="is-student sus flex min-h-screen w-full flex-col justify-between max-lg:pb-navbar-height"
    :class="
      isLowerGrade
        ? 'sus-first-level bg-peach-500'
        : 'sus-second-level bg-violet-dark-500'
    "
    :style="{
      '--hero-top-ident': 0,
    }"
  >
    <Tab />
    <StudentNavigationDesktop v-if="isLargeScreen" id="jump-navigation" />

    <slot />

    
    <StudentNavigationMobile v-if="!isLargeScreen" />
    <AppFooter />
  </div>
</template>

<script setup lang="ts">
const auth = useAuthStore()

const icon = useFavicon()

icon.value = '/favicon-student.svg'

const isLargeScreen = useMediaQuery('(min-width: 1024px)')

const { isLowerGrade } = useStudentSchoolYears(auth.student!)
if (isLowerGrade.value) {
  document.body.classList.remove('sus-second-level')
  document.body.classList.add('sus-first-level')
} else {
  document.body.classList.remove('sus-first-level')
  document.body.classList.add('sus-second-level')
}
</script>
